import { useEffect, useRef } from 'preact/hooks'
import * as bootstrap from 'bootstrap'

/**
 * Show/hide a Bootstrap modal from a Preact `open` flag.
 * Calls onHidden when the modal is fully hidden (incl. backdrop click / Esc).
 */
export function useBootstrapModal(open, onHidden) {
  const ref = useRef(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return undefined
    const modal = bootstrap.Modal.getOrCreateInstance(el)
    const handleHidden = () => onHidden?.()
    el.addEventListener('hidden.bs.modal', handleHidden)
    if (open) modal.show()
    else modal.hide()
    return () => {
      el.removeEventListener('hidden.bs.modal', handleHidden)
    }
  }, [open, onHidden])

  return ref
}

export function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content
}
